import { render } from "./inventariolimpiezarestaurante.vue?vue&type=template&id=3c4f1740&scoped=true"
import script from "./inventariolimpiezarestaurante.vue?vue&type=script&lang=js"
export * from "./inventariolimpiezarestaurante.vue?vue&type=script&lang=js"

import "./inventariolimpiezarestaurante.vue?vue&type=style&index=0&id=3c4f1740&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4f1740"]])

export default __exports__